import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import styles from './DisbursementPage.module.css';
import DisbursementTable from './Components/DisbursementTable.js';
import AddDisbursement from './Components/AddDisbursement.js';
import FinancialService from '../../../../AppSettings/services/FinancialService';

const DisbursementPage = () => {
  const { matterId } = useParams();
  const [data, setData] = useState([]);
  const [isAddDisbursementVisible, setIsAddDisbursementVisible] =
    useState(false); // State for popup visibility

  useEffect(() => {
    const fetchDisbursements = async () => {
      try {
        const disbursements = await FinancialService.getAgentDisbursements(
          matterId
        );
        setData(disbursements);
      } catch (error) {
        console.error('Error fetching disbursements:', error);
      }
    };

    fetchDisbursements();
  }, [matterId]);

  const handleAddDisbursementSuccess = () => {
    // Refresh the disbursement list after adding a new entry
    const fetchDisbursements = async () => {
      try {
        const disbursements = await FinancialService.getAgentDisbursements(
          matterId
        );
        setData(disbursements);
      } catch (error) {
        console.error('Error refreshing disbursements:', error);
      }
    };
    fetchDisbursements();
  };

  return (
    <div className={styles.DisbursementPage}>
      <div className={styles['Disbursement-header']}>
        <h1>Disbursements</h1>
        <button
          className={styles['Disbursement-add-button']}
          onClick={() => setIsAddDisbursementVisible(true)} // Show the AddDisbursement popup
        >
          +
        </button>
      </div>
      <DisbursementTable data={data} />

      {/* Show AddDisbursement popup when the button is clicked */}
      {isAddDisbursementVisible && (
        <AddDisbursement
          onClose={() => setIsAddDisbursementVisible(false)} // Close the popup
          onAddSuccess={handleAddDisbursementSuccess} // Refresh the list after a successful add
        />
      )}
    </div>
  );
};

export default DisbursementPage;
